:host {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;

  & > * {
    flex: 1;
  }

  .cell-edit-field {
    display: none;
  }

  .cell-default-label {
    display: inline;
  }

  .cell-edit-label,
  .cell-default-label {
    font-size: var(--body-size);
  }
}

:host([cancopycontent]) {
  padding-right: calc(var(--spacer) * 2);
}

:host([active]) {
  .cell-edit-field {
    display: block;
  }

  .cell-edit-label {
    display: none;
  }

  gz-enum-filter {
    height: 100%;
  }
}

gz-form-field {
  --margin-bottom-wrapper: 0;
}

.form-field-single-select,
.form-field-enum {
  position: absolute;
}

.form-field-enum {
  top: 0;
  width: 100%;
}

gz-enum-filter {
  position: absolute;
  top: 4px;
  width: calc(100% - var(--spacer) * 2);
  height: auto;
}

.checkbox-field {
  position: relative;
  height: 18px;

  gz-checkbox {
    position: absolute;
    bottom: 0;
    top: 0;
    height: 18px;
  }
}
